<template>
  <div class="slider-container" :class="[{ dark, faded, 'on-last': onLast, 'on-first': transform === 0, 'business': $route.name.startsWith('business') }, className]">
    <div v-show="!arrowsDown && !noHeader" class="slider-header">
      <div class="heading" :class="[columns]">
        <slot name="heading" class="heading" />
      </div>
      <div class="subtitle">
        <slot name="subtitle" class="subtitle" />
      </div>
      <div v-show="!(transform === 0 && (onLast || disabled))" class="controls">
        <slot name="controls" />
        <CaretLeftCircle
          :class="{ disabled: transform === 0 }"
          @click="prevSlide"
        />
        <CaretRightCircle
          :class="{ disabled: onLast || disabled }"
          @click="nextSlide"
        />
      </div>
    </div>
    <slot name="description" />
    <div
      v-swipe.right="prevSlide" v-swipe.left="nextSlide"
      class="row swiper"
      :style="[{ transform: `translateX(${transform}px)` }, startFromCenter ? { 'margin': 0 } : '']"
    >
      <slot name="slide" />
    </div>
    <div v-show="(!mobileNoSwipe || dotsControllers) && !noControllers" class="dots" :class="{ show: dotsControllers }">
      <div
        v-for="idx in slides"
        :key="idx" class="dot"
        :class="{ active: active === idx - 1 }"
        @click="setActive(idx)"
      />
    </div>
    <div v-show="className === 'courses' && $store.state.layout === 'mobile' || !(transform === 0 && (onLast || disabled))" class="courses-controls">
      <CaretLeftCircle
        :class="{ disabled: transform === 0 }"
        @click="prevSlide"
      />
      <CaretRightCircle
        :class="{ disabled: onLast || disabled }"
        @click="nextSlide"
      />
    </div>
    <div v-show="arrowsDown && !dotsControllers && !noControllers" class="slider-header-down">
      <div v-show="!(transform === 0 && (onLast || disabled))" class="controls">
        <slot name="controls" />
        <CaretLeftCircle
          :class="{ disabled: transform === 0 }"
          @click="prevSlide"
        />
        <CaretRightCircle
          :class="{ disabled: onLast || disabled }"
          @click="nextSlide"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CaretLeftCircle from '../assets/svg/caret-left-circle.svg?vue-component';
import CaretRightCircle from '../assets/svg/caret-right-circle.svg?vue-component';

export default {
  components: {
    CaretLeftCircle, CaretRightCircle,
  },
  props: {
    dark: { type: Boolean },
    faded: { type: Boolean },
    disabled: { type: Boolean },
    disableSwipes: Boolean,
    className: { type: String, default: '' },
    gutter: { type: Number, default: 30, required: false },
    mobileNoSwipe: { type: Boolean },
    arrowsDown: { type: Boolean },
    dotsControllers: { type: Boolean },
    noControllers: { type: Boolean },
    startFromCenter: { type: Boolean },
    dividers: { type: Boolean },
    noHeader: { type: Boolean },
    position: { type: Number, required: false, default: 0 },
    columns: { type: String, default: '', required: false },
    buffer: { type: Number, default: 24, required: false },
  },
  data: () => ({
    transform: 0,
    containerWidth: 0,
    cardWidth: 0,
    onLast: false,
    active: 0,
  }),
  computed: {
    slides() {
      let count = this.$slots.slide.length;

      if (this.className === 'featured-courses') {
        return count;
      }

      if (this.$store.state.tablet || (this.className === 'library-technologies' && this.$store.state.layout === 'mobile')) {
        count -= 1;
      }

      return count;
    },
  },
  mounted() {
    this.active = this.position;
    this.$root.$on('swipeToPrev', () => this.prevSlide(true));
    this.$root.$on('swipeToNext', () => this.nextSlide(true));

    setTimeout(() => {
      this.init();
    }, 1000);
    window.addEventListener('resize', this.resize);
  },
  methods: {
    init() {
      // paddings fixes last element not showing
      const sliderStyles = getComputedStyle(this.$el);
      const paddings = +sliderStyles.paddingLeft.replace('px', '') + +sliderStyles.paddingRight.replace('px', '');

      if (this.containerWidth !== this.$el.offsetWidth - paddings) {
        this.containerWidth = this.$el.offsetWidth - paddings;
        this.cardWidth = this.$el.querySelector('.col').offsetWidth;
        if (this.startFromCenter || this.position) {
          if (this.className !== 'notification-tabs') {
            const dividerWidth = this.$el.querySelector('.col .divider') ? this.$el.querySelector('.col .divider').offsetWidth : 0;
            this.$el.querySelector('.row').style.paddingLeft = `calc(50% - ${this.cardWidth / 2 - (dividerWidth / 2) - 4}px)`;
          }
        }

        if (this.$store.state.layout === 'mobile') {
          this.transform = this.cardWidth * -this.active;
        } else {
          this.transform = 0;
          this.active = 0;
          this.onLast = false;
        }

        if (this.$el.querySelectorAll('.col').length * this.cardWidth - this.gutter <= this.containerWidth) {
          this.onLast = true;
        }
      }
    },
    nextSlide(clickedToSwipe = false) {
      if ((this.mobileNoSwipe || this.disableSwipes) && this.$store.state.layout === 'mobile') {
        return;
      }
      const cols = this.$el.querySelectorAll('.col');
      const lastCard = [].slice.call(cols).pop().getBoundingClientRect();
      const totalCards = this.$el.querySelectorAll('.col').length * this.cardWidth;

      if (!this.onLast) {
        const cardWidth = this.faded ? this.cardWidth / 2 : this.cardWidth;
        let buffer = this.buffer || 24;

        if (this.faded) {
          buffer = 115;
        } else if (this.className.split('-')[0] === 'library') {
          buffer = (this.containerWidth % this.cardWidth) + 24;
        } else if (this.className === 'courses') {
          buffer = 48;
        } else if (this.startFromCenter) {
          buffer += cardWidth + (this.containerWidth / 2 - (this.cardWidth / 2 - 4)) + (this.dividers ? cardWidth / 2 : 0);
        }

        if (this.containerWidth - totalCards <= this.transform + -cardWidth + buffer) {
          if (this.className === 'notification-tabs' && this.$store.state.layout === 'mobile') {
            if (this.position + 1 === 1) {
              this.transform += -103;
            } else {
              this.transform += -this.cardWidth;
            }
          } else {
            this.transform += -cardWidth;
          }
        }

        if (this.active < this.slides - 1) {
          this.active += 1;
        }

        buffer = 12;

        if (this.faded) {
          if (this.className === 'notification-tabs' && this.$store.state.layout === 'mobile') {
            buffer = this.$store.state.sideBarExpanded ? 162 : 174;
          } else {
            buffer = this.$store.state.sideBarExpanded ? 162 : 103;
          }
        } else if (this.className.split('-')[0] === 'library') {
          buffer = (this.containerWidth % this.cardWidth) + 12;
        }

        if (!this.startFromCenter && (lastCard.left - this.$el.getBoundingClientRect().left) + buffer < this.containerWidth + cardWidth) {
          this.onLast = true;
        }
      }

      if (!clickedToSwipe) {
        this.$emit('next');
      }
    },
    prevSlide(clickedToSwipe = false) {
      if ((this.mobileNoSwipe || this.disableSwipes) && this.$store.state.layout === 'mobile') {
        return;
      }

      const cardWidth = this.faded ? this.cardWidth / 2 : this.cardWidth;
      if (this.transform + cardWidth <= 0) {
        if (this.className === 'notification-tabs' && this.$store.state.layout === 'mobile') {
          if (this.position - 1 === 0) {
            this.transform = 0;
          } else {
            this.transform -= -this.cardWidth;
          }
        } else {
          this.transform -= -cardWidth;
        }
        this.onLast = false;
        this.active -= 1;
      } else if (this.className === 'notification-tabs') {
        this.transform = 0;
      }
      if (!clickedToSwipe) {
        this.$emit('prev');
      }
    },
    resize() {
      this.init();
    },
    setActive(idx) {
      this.active = idx - 1;
      this.transform = this.cardWidth * -this.active;
    },
  },
};
</script>

<style lang="scss">
.slider-container {
  overflow: hidden;
  padding: 0 10px;
  margin-left: -10px;
  margin-right: -10px;

  &.landing {
    .slider-header {
      flex-direction: column;
      margin-bottom: var(--spacing-60);

      .heading {
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 34px;

        h2 {
          width: 100%;
          margin: 0;
        }
      }

      .subtitle {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
      }
    }
  }

  &.courses {
    .slider-header {
      margin-bottom: var(--spacing-24);

      .controls {
        svg path[stroke],
        svg circle[stroke] {
          stroke: var(--main-dark-light-4);
        }
      }
    }
  }

  &.business {
    .slider-header {
      .controls {
        svg {
          &.disabled {
            path[stroke],
            circle[stroke] {
              stroke: var(--main-light-shade-4);
            }
          }

          path[stroke],
          circle[stroke] {
            stroke: var(--main-dark-light-4);
          }
        }
      }
    }
  }

  &.resources {
    .slider-header {
      margin: 0;
    }
  }

  .row {
    justify-items: stretch;
    transform: translateX(0);
    transition: transform 1s ease-out;
    flex-wrap: nowrap;
  }

  .faded-el {
    width: 53px;
    height: 100%;
    background: linear-gradient(180deg, var(--main-light-shade-1) 0%, rgba(250, 250, 251, 0) 100%);
    transform: rotate(90deg);
    position: absolute;
    z-index: 1;
    bottom: 0;
    right: 0;
    pointer-events: none;
    transition: all 1s ease;
  }

  .slider-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 36px;

    .controls {
      display: flex;
      align-items: center;

      a {
        margin-right: var(--spacing-36);
        color: var(--main-light);
        text-decoration: none;
        font-size: 18px;
        font-weight: 600;
        line-height: 18px;
      }

      svg {
        cursor: pointer;

        &.disabled {
          pointer-events: none;
          opacity: 0.3;
        }
      }

      svg:not(:last-child) {
        margin-right: var(--spacing-14);
      }
    }
  }

  .slider-header-down {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: var(--spacing-48);

    .controls {
      display: flex;
      align-items: center;

      a {
        margin-right: var(--spacing-36);
        color: var(--main-light);
        text-decoration: none;
        font-size: 18px;
        font-weight: 600;
        line-height: 18px;
      }

      svg {
        cursor: pointer;

        &.disabled {
          pointer-events: none;
          opacity: 0.3;
        }
      }

      svg:not(:last-child) {
        margin-right: var(--spacing-14);
      }
    }
  }

  .dots {
    z-index: 3;
    display: none;
    justify-content: center;
    padding: var(--spacing-18) 0;

    .dot {
      width: 20px;
      height: 20px;
      margin: 0 var(--spacing-8);
      display: flex;
      align-items: center;
      justify-content: center;

      &:after {
        content: '';
        display: block;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: rgba(0, 12, 31, 0.36);
        transition: background-color 500ms ease-in;
      }

      &.active:after {
        background-color: var(--main-dark-shade-1);
      }
    }

    &.show {
      display: flex;
    }
  }

  .courses-controls {
    display: none;
  }

  &.dark {
    .controls svg {
      circle[fill] {
        fill: transparent;
      }

      circle[stroke] {
        stroke: var(--main-light);
      }

      path[stroke] {
        stroke: var(--main-light);
      }
    }

    .dots .dot {
      &.active:after {
        background-color: var(--main-light);
      }

      &:after {
        background-color: var(--main-dark-shade-3);
      }
    }
  }
}

@include bp($bp-mobile) {
  .slider-container {
    &.landing {
      margin-left: 0;
      margin-right: 0;
      padding-left: 24px;
      padding-right: 24px;

      .slider-header {
        .controls {
          display: flex;
        }
      }

      .dots {
        display: none;
      }
    }

    &.courses {
      .slider-header {
        margin-bottom: 0;
      }

      .dots {
        display: none;
      }

      .courses-controls {
        display: none;
      }

      .row.expanded ~ .courses-controls {
        display: flex;
        justify-content: center;
        margin-bottom: 20px;

        svg {
          &:first-of-type {
            margin-right: var(--spacing-12);
          }

          &.disabled {
            pointer-events: none;
            opacity: 0.3;
          }

          path[stroke],
          circle[stroke] {
            stroke: var(--main-dark-light-4);
          }
        }
      }
    }

    .slider-header {
      .controls {
        display: none;
      }
    }

    .dots {
      display: flex;
    }

    &.featured-courses {
      margin: 0 !important;
      padding: 0;
    }
  }
}

.fa {
  @import '../assets/sass/fa/components/slider.scss';
}
</style>
